export const MANUAL_SALARY_ASSIGNMENT_NOT_SELECTED = "notSelected";

export const hasManualSalaryAssignment = (
  assignmentId?: string | null,
): boolean =>
  !!assignmentId && assignmentId !== MANUAL_SALARY_ASSIGNMENT_NOT_SELECTED;

type ManualSalaryTargetSource = {
  manualSalaryId?: string;
  assignmentId?: string | null;
  customerCostCenterId?: string | null;
  eezyCostCenterId?: string | null;
} | null;

export const manualSalaryAssignmentDefaults = (
  manualSalary: ManualSalaryTargetSource,
) => {
  const isEdit = !!manualSalary?.manualSalaryId;
  return {
    assignmentId: isEdit
      ? manualSalary?.assignmentId || ""
      : MANUAL_SALARY_ASSIGNMENT_NOT_SELECTED,
    // A copy has no manualSalaryId, so the assignment is forced back to
    // "not selected". Do not keep the source customer cost center or it is
    // submitted without an assignment.
    customerCostCenterId: isEdit
      ? manualSalary?.customerCostCenterId || ""
      : "",
    eezyCostCenterId: manualSalary?.eezyCostCenterId || "",
  };
};

export const manualSalaryTargetPayload = (values: {
  assignmentId?: string | null;
  customerCostCenterId?: string | null;
  eezyCostCenterId?: string | null;
}) => {
  const hasAssignment = hasManualSalaryAssignment(values.assignmentId);
  return {
    assignmentId: hasAssignment ? (values.assignmentId ?? null) : null,
    customerCostCenterId:
      hasAssignment && values.customerCostCenterId
        ? values.customerCostCenterId
        : null,
    eezyCostCenterId:
      !hasAssignment && values.eezyCostCenterId ? values.eezyCostCenterId : null,
  };
};

export enum ExpenseTypeGroupNames {
  Luontoisetu = "Luontoisetu",
  Nettomuutos = "Nettomuutos",
  Palkka = "Palkka",
  Poissaolo = "Poissaolo",
  Vuosilomapalkka = "Vuosilomapalkka ja -raha",
  Verottomat = "Verottomat korvaukset",
}
